<template>
  <v-container fluid class="pt-3" v-if="product != null">
    <vue-headful :title="`รายละเอียดสินค้า - Halal Delivery`" />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>สินค้า</el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{ path: '/view/shop/' + product.shop.ref_no }">{{
        product.shop.name
      }}</el-breadcrumb-item> -->
      <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>

    <section class="mt-4">
      <el-tabs :tab-position="`top`">
        <el-tab-pane label="ข้อมูลทั่วไป">
          <v-layout>
            <v-flex xs12 md8>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="font-weight-bold">ข้อมูลสินค้า</span>
                  <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    v-if="!editDetail"
                    @click="editDetail = true"
                    >แก้ไข</el-button
                  >
                </div>
                <v-layout>
                  <v-flex xs12>
                    <el-form
                      :label-position="`top`"
                      label-width="100px"
                      size="mini"
                    >
                      <el-form-item label="สถานะ">
                        <el-select v-model="product.status" placeholder="เลือก">
                          <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="ประเภท">
                        <el-col :span="19">
                          <el-radio-group v-model="product.product_type">
                            <el-radio :label="`a_la_carte`"
                              >สินค้าทั่วไป</el-radio
                            >
                            <el-radio :label="`customise`"
                              >สินค้าที่มีตัวเลือก</el-radio
                            >
                            <el-radio :label="`product`"
                              >สินค้าอีคอมเมิร์ซ</el-radio
                            >
                            <el-radio :label="`coupon`" :disabled="true"
                              >คูปอง/บัตรกำนัล</el-radio
                            >
                            <el-radio :label="`free_item`">ของแถม</el-radio>
                            <el-radio :label="`buffet`">บุฟเฟต์</el-radio>
                          </el-radio-group>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="ชื่อสินค้า">
                        <el-input v-model="product.name"></el-input>
                      </el-form-item>
                      <el-form-item label="คำอธิบาย">
                        <el-input v-model="product.excerpt"></el-input>
                      </el-form-item>
                      <el-form-item label="รายละเอียด">
                        <wysiwyg v-model="product.description" />

                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4 }"
                          v-model="product.description"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="มีส่วนลด">
                        <el-col :span="3">
                          <el-switch v-model="enableSpecialPrice"></el-switch>
                        </el-col>
                        <el-col :span="9"> </el-col>
                      </el-form-item>

                      <div v-if="enableSpecialPrice">
                        <el-row>
                          <el-col :span="11">
                            <el-form-item label="ราคาเก่า (ขีดฆ่า)">
                              <el-input
                                v-model="product.full_price"
                                type="number"
                              ></el-input>
                            </el-form-item>
                          </el-col>

                          <el-col :span="2">&nbsp;</el-col>
                          <el-col :span="11"> </el-col>
                        </el-row>

                        <el-row>
                          <el-col :span="11">
                            <el-form-item
                              label="ราคาพิเศษ (ถ้าไม่่มีให้เว้นว่าง)"
                            >
                              <el-input
                                v-model="product.regular_price"
                                type="number"
                              ></el-input>
                            </el-form-item>
                          </el-col>

                          <el-col :span="2">&nbsp;</el-col>
                          <el-col :span="11"> </el-col>
                        </el-row>
                      </div>

                      <div v-else>
                        <el-row>
                          <el-col :span="11">
                            <el-form-item label="ราคาปกติ">
                              <el-input
                                v-model="product.regular_price"
                                type="number"
                              ></el-input>
                            </el-form-item>
                          </el-col>

                          <el-col :span="2">&nbsp;</el-col>
                          <el-col :span="11"> </el-col>
                        </el-row>
                      </div>

                      <el-row class="mt-2">
                        <el-col :span="11">
                          <el-form-item label="รหัสบาร์โค้ด">
                            <el-input
                              v-model="product.barcode"
                              type="number"
                            ></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11"> </el-col>
                      </el-row>

                      <el-row class="mt-2">
                        <el-col :span="11">
                          <el-form-item label="ITEMCODE">
                            <el-input
                              v-model="product.casio_itemcode"
                              type="text"
                            ></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11"> </el-col>
                      </el-row>

                      <!--
                      <el-form-item label="Special Price (THB)">
                        <el-col :span="3">
                          <el-switch v-model="enableSpecialPrice"></el-switch>
                        </el-col>
                        <el-col :span="9">
                          <el-input
                            type="number"
                            v-model="product.special_price"
                            :disabled="!enableSpecialPrice"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                      -->
                      <v-divider class="my-4"></v-divider>
                      <el-form-item size="mini" class="mt-3">
                        <el-button type="danger" @click="onProductDetailSubmit"
                          >บันทึก</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </v-flex>
                </v-layout>
              </el-card>

              <el-card class="my-5">
                <div slot="header" class="clearfix">
                  <span class="font-weight-bold">สต้อกสินค้า</span>
                </div>
                <v-layout>
                  <v-flex xs12>
                    <el-form
                      :label-position="`top`"
                      label-width="100px"
                      size="mini"
                    >
                      <el-row class="mt-2">
                        <el-col :span="11">
                          <div class="mb-4">
                            คงเหลือ : {{ product.inventory.remain }}
                          </div>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11"> </el-col>
                      </el-row>
                      <el-row class="mt-2">
                        <el-col :span="11">
                          <el-form-item label="">
                            <el-checkbox
                              v-model="product.enable_daily_limit"
                              label="จำกัดจำนวนการขาย"
                            ></el-checkbox>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11"> </el-col>
                      </el-row>

                      <el-row class="mt-2">
                        <el-col :span="11">
                          <el-form-item label="สต้อก">
                            <el-input
                              v-model="product.sold_daily_limit"
                              type="number"
                            ></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11"> </el-col>
                      </el-row>

                      <el-row class="mt-2">
                        <el-col :span="11">
                          <el-form-item label="">
                            <el-checkbox
                              v-model="reset_sold_display"
                              label="รีเซ็ตจำนวนขาย"
                            ></el-checkbox>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2">&nbsp;</el-col>
                        <el-col :span="11"> </el-col>
                      </el-row>

                      <v-divider class="my-4"></v-divider>
                      <el-form-item size="mini" class="mt-3">
                        <el-button type="danger" @click="onProductStockSubmit"
                          >ปรับสต้อกสินค้า</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </v-flex>
                </v-layout>
              </el-card>
            </v-flex>
            <v-flex xs12 md4 class="pl-2">
              <el-form>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">หมวดหมู่สินค้า</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="categoryDialog = true"
                      >เพิ่ม</el-button
                    >
                  </div>
                  <v-layout wrap column>
                    <v-flex
                      class="my-2"
                      xs12
                      v-for="(item, index) in categoryList"
                      v-bind:key="index"
                    >
                      <el-radio
                        v-model="product.groups[0].id"
                        :label="item.product_cate_id"
                        >{{ item.name }}</el-radio
                      >
                    </v-flex>
                  </v-layout>
                  <v-divider class="my-4"></v-divider>
                  <el-form-item size="mini" class="mt-3">
                    <el-button type="danger" @click="onProductCategorySubmit"
                      >บันทึก</el-button
                    >
                  </el-form-item>
                </el-card>
                <create-category
                  :dialog="categoryDialog"
                  :shop_id="shop_id"
                  @close="categoryDialog = false"
                  @save="loadCategories"
                ></create-category>
              </el-form>

              <el-card class="mt-4 box-card">
                <div slot="header" class="clearfix">
                  <span class="font-weight-bold">Image</span>
                </div>
                <div class="text-center mb-3">
                  <img :src="product.image" style="width: 50%" />
                </div>
                <picture-input
                  ref="pictureInput"
                  width="150"
                  height="150"
                  margin="0"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="btn"
                  :custom-strings="{
                    upload: '<h1>Upload Picture!</h1>',
                    drag: 'อัพโหลดรูปที่นี่',
                  }"
                  @change="onImageChanged"
                ></picture-input>
              </el-card>
            </v-flex>
          </v-layout>
        </el-tab-pane>
        <el-tab-pane
          v-if="product.product_type == 'buffet'"
          label="รายการสินค้าในบุฟเฟต์"
        >
          <v-row>
            <v-col xs12>
              <el-card class="box-card mx-3 mb-5">
                <div slot="header" class="clearfix">
                  <span class="font-weight-bold"
                    >สินค้าใน {{ product.name }}</span
                  >
                  <el-button
                    :disabled="true"
                    style="float: right"
                    size="small"
                    type="info"
                    @click="productUploadDrawer = true"
                    >อัพโหลด</el-button
                  >

                  <el-button
                    style="float: right"
                    class="mr-2"
                    size="small"
                    type="danger"
                    @click="productDrawer = true"
                    >เพิ่มสินค้าใหม่</el-button
                  >
                </div>
                <div>
                  <el-table
                    :data="productBuffetList"
                    style="width: 100%; height: 100%"
                  >
                    <el-table-column
                      prop="product_id"
                      label="ID"
                      width="60"
                    ></el-table-column>
                    <el-table-column label="สถานะ" width="120">
                      <template slot-scope="props">
                        <el-select
                          v-model="props.row.status"
                          placeholder="Select"
                          :size="`mini`"
                          @change="onUpdateStatus(props.row)"
                        >
                          <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="ชื่อสินค้า" width="350">
                      <template slot-scope="props">
                        <div style="min-height: 65px">
                          <div
                            class="pic"
                            :style="{
                              backgroundImage: 'url(' + props.row.image + ')',
                            }"
                          ></div>
                          <div style="padding-left: 60px" class="pr-3">
                            <div class="font-weight-bold line-1-elipsis">
                              {{ props.row.name }}
                            </div>
                            <div class="grey--text font-xs line-1-elipsis">
                              {{ props.row.excerpt }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="หมวดหมู่" width="250">
                      <template slot-scope="props">
                        <el-select
                          v-model="props.row.groups[0].id"
                          placeholder="Select"
                          :size="`mini`"
                          @change="onUpdateCategory(props.row)"
                        >
                          <el-option
                            v-for="item in categoryList"
                            :key="item.product_cate_id"
                            :label="item.name"
                            :value="item.product_cate_id"
                          ></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="regular_price"
                      label="ราคา"
                    ></el-table-column>
                    <!--
                      <el-table-column prop="cog" label="ต้นทุน"></el-table-column>
                      
                      <el-table-column label align="right">
                        <template slot-scope="props">
                          <el-button
                            type="text"
                            size="small"
                            @click="openProduct(props.row)"
                            >รายละเอียด</el-button
                          >
                        </template>
                      </el-table-column>-->
                  </el-table>
                </div>
              </el-card>
            </v-col>
          </v-row>
        </el-tab-pane>
        <el-tab-pane label="การปรับแต่ง">
          <template
            v-if="
              product.product_type == 'customise' ||
                product.product_type == 'product_customise'
            "
          >
            <v-layout>
              <v-flex xs12 sm4 md4>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold"
                      >Pick customise Template</span
                    >
                  </div>
                  <v-layout>
                    <v-flex xs12>
                      <ul class="hlz-list">
                        <li @click="onTemplateClicked('c1fm')">
                          Choose
                          <strong>1</strong> from x choices.
                        </li>
                        <li @click="onTemplateClicked('cmfm')">
                          Choose
                          <strong>many</strong> from x choices
                        </li>
                      </ul>

                      <div class="mt-4">
                        <div>
                          <el-button
                            style="width: 100%"
                            type="text"
                            @click="customiseDialog = true"
                            >Test Customise</el-button
                          >
                        </div>
                        <div class="mt-3">
                          <el-button
                            style="width: 100%"
                            type="primary"
                            @click="onCustomiseUpdated"
                            >Update Customise</el-button
                          >
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </el-card>
              </v-flex>
              <v-flex xs12 sm8 md8 class="pl-4">
                <!-- START SUBJECT -->
                <customise-subject
                  :subject="subject"
                  v-for="(subject, i) in customise_json"
                  v-bind:key="i"
                  @remove="onRemoveSubject(i)"
                ></customise-subject>
                <!-- END SUBJECT -->
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <div class="pa-3 text-xs-center">
              This is not customise product.
            </div>
          </template>
        </el-tab-pane>
        <!-- <el-tab-pane label="ประวัติการขาย"></el-tab-pane> -->
      </el-tabs>
    </section>

    <customise-dialog
      :customise_json="customise_json"
      :dialog="customiseDialog"
      @done="onCustomiseProductClosed"
      @close="onCustomiseProductClosed"
    ></customise-dialog>

    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <create-product-drawer
      :dialog="productDrawer"
      :shopId="product.shop_id"
      :parentId="product.product_id"
      @close="productDrawer = false"
      @save="onProductCreated"
    ></create-product-drawer>
  </v-container>
</template>
<script>
import moment from "moment";
import Service from "@/services";
import CustomiseSubject from "@/components/CustomiseSubject";
import CustomiseDialog from "@/components/CustomiseDialog";
import CreateCategory from "@/components/product/CreateCategory";
import CreateProductDrawer from "@/components/CreateProductDrawer";
import PictureInput from "vue-picture-input";

export default {
  components: {
    CustomiseSubject,
    CustomiseDialog,
    CreateCategory,
    PictureInput,
    CreateProductDrawer,
  },
  props: ["product_id"],
  data() {
    return {
      loadingDialog: false,
      customiseDialog: false,
      categoryDialog: false,
      productDrawer: false,
      productUploadDrawer: false,
      product: null,
      shop_id: null,
      statusList: [
        { label: "ปิดการใช้งาน", value: "draft" },
        // { label: "ไม่พร้อมขาย", value: "inactive" },
        { label: "ใช้งานอยู่", value: "published" },
        { label: "ขายหมด", value: "soldout" },
      ],
      editDetail: false,
      enableSpecialPrice: false,
      title: "",
      customise_json: [],
      categoryList: [],
      productBuffetList: [],
      reset_sold_display: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      Service.Product.getWithStock(
        this.product_id,
        moment().format("YYYY-mm-dd")
      ).then((res) => {
        if (res.success) {
          this.product = res.data.product;
          if (this.product.enable_daily_limit == 1) {
            this.product.enable_daily_limit = true;
          } else {
            this.product.enable_daily_limit = false;
          }

          this.enableSpecialPrice = false;
          if (this.product.full_price != null) {
            this.enableSpecialPrice = true;
          }

          console.log(this.product);
          this.shop_id = res.data.shop_id;
          this.title = this.product.name;
          if (this.product.modifiers != null) {
            this.customise_json = this.product.modifiers;
          }
          this.loadCategories();
          if (this.product.product_type == "buffet") {
            this.loadChildrenProduct();
          }
        }
      });
    },
    loadCategories() {
      Service.Shop.getCategories(this.product.shop_id).then((res) => {
        if (res.success) {
          this.categoryList = res.data;
          this.categoryList.push({
            name: "อื่นๆ",
            product_cate_id: 0,
            rank: 9999,
          });
        }
      });
      this.categoryDialog = false;
    },
    loadChildrenProduct() {
      Service.Delivery.getProductByShop(
        this.product.shop_id,
        this.product.product_id
      ).then((res) => {
        this.productBuffetList = res.data;
      });
    },
    onProductDetailSubmit() {
      this.loadingDialog = true;

      if (this.enableSpecialPrice == false) {
        this.product.full_price = null;
      }
      let data = {
        product_id: this.product.product_id,
        status: this.product.status,
        product_type: this.product.product_type,
        product_name: this.product.name,
        product_excerpt: this.product.excerpt,
        product_description: this.product.description,
        regular_price: this.product.regular_price,
        barcode: this.product.barcode,
        // enable_daily_limit: this.product.enable_daily_limit,
        // sold_daily_limit: this.product.sold_daily_limit,
      };

      if (this.product.full_price != null) {
        data.full_price = this.product.full_price;
      }
      if (data.enable_daily_limit) {
        data.enable_daily_limit = 1;
      }

      if (this.enableSpecialPrice && this.product.special_price != null) {
        data = { ...data, special_price: this.product.special_price };
      }

      Service.Product.update(data).then((res) => {
        this.loadingDialog = false;
        this.fetchData();
      });
    },

    onProductStockSubmit() {
      this.loadingDialog = true;
      let data = {
        product_id: this.product.product_id,
        enable_daily_limit: this.product.enable_daily_limit,
        sold_daily_limit: this.product.sold_daily_limit,
        reset_sold_display: this.reset_sold_display,
      };

      Service.Product.update(data).then((res) => {
        this.loadingDialog = false;
        this.fetchData();
      });
    },
    onProductCategorySubmit() {
      this.loadingDialog = true;
      let data = {
        product_id: this.product.product_id,
        shop_id: this.product.shop_id,
        product_cate_id: this.product.groups[0].id,
      };

      Service.Product.update(data).then((res) => {
        this.loadingDialog = false;
      });
    },
    onImageChanged(image) {
      let maxBytes = 1000000;
      let product_id = this.product.product_id;
      var i = new Image();
      i.onload = () => {
        // console.log(image);
        // var base64str = image.substr(22);
        // var decoded = atob(base64str);

        // if (i.width != i.height) {
        //   alert("รูปภาพต้องเป็น 1:1");
        // } else {

        // }
        if (image) {
          let data = {
            image: image,
            product_id: product_id,
          };
          Service.Product.upload(data).then((res) => {
            this.fetchData();
          });
        } else {
          console.log("FileReader API not supported: use the <form>, Luke!");
        }
      };
      i.src = image;

      return;
    },
    onTemplateClicked(template) {
      let id = "s" + moment().format("X");
      let c1fm = {
        title: "ตัวเลือกเพิ่มเติม",
        items: [],
        required: true,
        duplicate: false,
        min: 1,
        max: 1,
        imageSize: "none",
        isValid: false,
      };
      let cmfm = {
        title: "ตัวเลือกเพิ่มเติม",
        items: [
          // {
          //   id: 113,
          //   name: "Item D",
          //   price: 0,
          //   cog: 0,
          // },
          // {
          //   id: 114,
          //   name: "Item F",
          //   price: 20,
          //   cog: 0,
          // },
        ],
        required: true,
        duplicate: true,
        min: 1,
        max: 1,
        imageSize: "small",
        isValid: false,
      };
      if (template == "c1fm") {
        this.customise_json.push({ id: id, ...c1fm });
      } else if (template == "cmfm") {
        this.customise_json.push({ id: id, ...cmfm });
      }
    },
    onRemoveSubject(index) {
      this.customise_json.splice(index, 1);
    },
    onCustomiseProductClosed() {
      this.customiseDialog = false;
    },
    onCustomiseUpdated() {
      console.log(this.customise_json);
      //* RESET PRE SELECTED */
      this.customise_json = this.customise_json.map((subject, x) => {
        if (subject.duplicate) {
          this.customise_json[x].items = subject.items.map((item, y) => {
            return { ...item, quantity: 0 };
          });
        } else {
          this.customise_json[x].items = subject.items.map((item, y) => {
            return { ...item, checked: false };
          });
        }
        return { ...subject, isValid: false };
      });
      console.log(this.customise_json);

      let data = {
        product_id: this.product_id,
        modifiers: JSON.stringify(this.customise_json),
      };

      Service.Product.update(data).then((res) => {
        console.log(res);
      });
    },
    onUpdateCategory(item) {
      let data = {
        product_id: item.product_id,
        shop_id: item.shop_id,
        product_cate_id: item.groups[0].id,
      };
      Service.Product.update(data).then((res) => {});
    },
    openProduct(item) {},
    onProductCreated(data) {
      this.productDrawer = false;
      this.loadChildrenProduct();
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  background-size: cover;
}
</style>
